export const GUIDE_ACCENT = '#E8341C';
export const GUIDE_ACCENT_HOVER = '#D42A15';

export const guideTokens = {
  accent: GUIDE_ACCENT,
  accentHover: GUIDE_ACCENT_HOVER,
  accentSoft: (isDark: boolean) =>
    isDark ? 'rgba(232, 52, 28, 0.16)' : 'rgba(232, 52, 28, 0.10)',
  accentBorder: (isDark: boolean) =>
    isDark ? 'rgba(232, 52, 28, 0.45)' : 'rgba(232, 52, 28, 0.35)',
  fontDisplay: '"Plus Jakarta Sans", "Inter", system-ui, sans-serif',
  fontBody: '"Inter", system-ui, sans-serif',
  radiusCard: 14,
  radiusFigure: 20,
} as const;

export const guideContainedButtonSx = {
  textTransform: 'none' as const,
  fontWeight: 700,
  fontFamily: guideTokens.fontDisplay,
  bgcolor: GUIDE_ACCENT,
  '&:hover': { bgcolor: GUIDE_ACCENT_HOVER },
};

export const guideOutlineButtonSx = {
  textTransform: 'none' as const,
  fontWeight: 600,
  fontFamily: guideTokens.fontDisplay,
  borderColor: 'divider',
  color: 'text.primary',
  '&:hover': {
    borderColor: GUIDE_ACCENT,
    bgcolor: 'transparent',
  },
};
